module.exports = __webpack_public_path__ + "static/img/certificate7.64f562b1.png";